import React from 'react'
import ArticleV2PaddedSectionWrap from './ArticleV2PaddedSectionWrap';
import { RichTextSerializer } from '../../../Serializers';
import DrawerIcon from '../../Icons/DrawerIcon';
import DrawerOpenIcon from '../../Icons/DrawerOpenIcon';
import {motion} from 'framer-motion'
import ArticleV2Image from './ArticleV2Image';
import ArticleV2VideoFile from './ArticleV2VideoFile';
import ArticleV2VideoYoutube from './ArticleV2VideoYoutube'
const ArticleV2DrawerSection = ({data}) => {
    const [isOpen, setIsOpen] = React.useState(false);

    
    return (
        <motion.div 
            layout="position" className='drawer-section'
            transition={{duration: 0.3}}
        >

            <h5 className='drawer__title' onClick={() => setIsOpen(!isOpen)}>
                {isOpen ? 
                    <DrawerOpenIcon/>:
                    <DrawerIcon/>
                }
                {data?.title}
            </h5>

            
            <motion.div
                layout
                style={{height: isOpen ? 'auto' : 0, overflow: 'hidden'}}
                transition={{duration: 0.3}}
            >
                <div className={`drawer__inner ${isOpen ? "open" : ""}`}>
                    <ArticleV2PaddedSectionWrap>
                        {data.body?.map((section, idx) => {
                            
                            if (section.__typename === 'ContentfulTextBlock') {
                                if (!section.content) return null;
                                return <RichTextSerializer content={section.content}/>  
                            } else if (section.__typename === 'ContentfulImage') {
                                return <ArticleV2Image image={section.image}/>
                            } else if (section.__typename === 'ContentfulVideo') {
                                let videoType = section.videoType;
                                let toRender = null;
            
                                switch(videoType) {
                                    case 'Video File':
                                        toRender = <ArticleV2VideoFile video={section.content}/>
                                        break;
                                    case "Youtube Embed":
                                        toRender = <ArticleV2VideoYoutube youtubeEmbedId={section.youtubeEmbedId}/>
                                        break;
                                    
                                }
            
                                return toRender
                            } else {
                                return null
                            }

                        })}
                    </ArticleV2PaddedSectionWrap>
                </div>
            </motion.div>

                
        



            <style jsx>{`
                .drawer__title {
                    font-size: 32px;
                    font-weight: 400;
                    text-align: center;
                    padding: 24px 80px;
                    background: ${data?.backgroundColor || '#f4f4f4'}};
                    cursor: pointer;
                    position: relative;
                }

                :global(.drawer-section) {
                    position: relative;
                }

                :global(.drawer-section:first-of-type) {
                    position: relative;
                    // display: none;
                }

                :global(.drawer-section .drawer-icon) {
                    height: 40px;
                    position: absolute;
                    top: 20px;
                    left: 12px;
                    pointer-events: none;
                }

                .drawer__inner {
                    overflow: auto;
                    padding: 40px 0;
                    opacity: 0;
                }
                .drawer__inner.open {
                    opacity: 1;
                    transition: opacity 0.3s ease-in-out .2s;
                }

                @media (max-width: 769px), (pointer: coarse) {
                    .drawer__title {
                        padding: 24px 50px;
                        font-size: 26px;
                        line-height: 1.3;
                    }
                    :global(.drawer-section .drawer-icon) {
                        height: 32px;
                        positin: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                        left: 0px;
                        pointer-events: none;
                    }
                }
            `}</style>  
        </motion.div>
    )
}

export default ArticleV2DrawerSection


export const query = graphql`
	fragment V2DrawerContent on ContentfulV2DrawerContent {
        id
        title
        backgroundColor
        body {

        ... on ContentfulVideo {
            id
            videoType
            youtubeEmbedId
            content {
                file {
                    url
                }
            }
        }
        ... on ContentfulTextBlock {
            id
            content {
                raw
            }
        }
          ... on ContentfulImage {
                id
                image {
                    file {
                        url
                    }
                    description
                }
            }
        }
	}
`